import { BoxTopMenuApi } from "./api.box";
import { CloudTopMenuApi } from "./api.cloud";
import { DemoTopMenuApi } from "./api.demo";
import { BaseTopMenuApi } from "./api.base";
import { getService } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default getService<BaseTopMenuApi>(environment.nexus, {
    box: new BoxTopMenuApi(),
    cloud: new CloudTopMenuApi(),
    demo: new DemoTopMenuApi(),
});